/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const controlledAccordionStyles = {
  container: {
    padding: 0,
  },
  heading: {
    fontWeight: 400,
  },
};

export default controlledAccordionStyles;
